import React, { createContext, useEffect, useReducer } from "react";
import { TotalFileSizeExceededError } from "./errors";

const DocumentContext = createContext();

const initialState = {
  documents: [],
  totalSize: 0,
  errors: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "add": {
      const { value, size } = action.payload;

      return {
        ...state,
        documents: [...state.documents, value],
        totalSize: state.totalSize + size,
        errors: {},
      };
    }

    case "remove": {
      const { name, size } = action.payload;

      return {
        ...state,
        documents: state.documents.filter((document) => document.name !== name),
        totalSize: state.totalSize - size,
      };
    }

    case "setError": {
      const { type, message } = action.payload;

      return {
        ...state,
        errors: {
          ...state.errors,
          [type]: message,
        },
      };
    }

    case "clearError": {
      const { type } = action.payload;

      const { errors } = state;
      const { [type]: value, ...restErrors } = errors;

      return {
        ...state,
        errors: restErrors,
      };
    }

    case "clearSize": {
      return { ...state, totalSize: 0 };
    }

    case "resetErrors": {
      return {
        ...state,
        errors: {},
      };
    }

    default:
      return state;
  }
};

const FILE_SIZE_LIMIT = 52428800; // Max 50MB

const DocumentProvider = ({ children }) => {
  const [store, dispatch] = useReducer(reducer, initialState);
  const { documents, errors, totalSize } = store;

  useEffect(() => {
    if (totalSize > FILE_SIZE_LIMIT) {
      const error = new TotalFileSizeExceededError();

      dispatch({
        type: "setError",
        payload: {
          type: TotalFileSizeExceededError.type,
          message: error.message,
        },
      });
    } else {
      dispatch({
        type: "clearError",
        payload: { type: TotalFileSizeExceededError.type },
      });
    }
  }, [documents, totalSize]);

  return (
    <DocumentContext.Provider
      value={{
        documents,
        dispatch,
        errors,
        totalSize,
      }}
    >
      {children}
    </DocumentContext.Provider>
  );
};

export { DocumentProvider, DocumentContext };
